module.exports = __webpack_public_path__ + "static/media/img-background3.c66fc2e7.jpg";